import styled from 'styled-components';
import theme from 'v3/theme';

export const Page = styled.div`
  position: relative;
  z-index: 0;
  isolation: isolate;
  min-height: calc(100vh - 100px);
  background-color: #fafafa;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    width: 100vw;
    transform: translateX(-50%);
    background-color: #fafafa;
    z-index: -1;
  }
`;

export const QuickAccessBand = styled.div`
  position: relative;
  z-index: 0;
  isolation: isolate;
  background-color: #e5e5e5;
  padding-left: 15px;
  padding-right: 15px;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    width: 100vw;
    transform: translateX(-50%);
    background-color: #e5e5e5;
    z-index: -1;
  }
`;

export const DashboardArea = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 1px minmax(0, 1fr);
  column-gap: 64px;
  min-height: calc(100vh - 216px);
  padding: 44px 0 72px;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
    row-gap: 32px;
    padding-top: 28px;
  }
`;

export const DashboardSection = styled.section`
  min-width: 0;
`;

export const VerticalRule = styled.div`
  border: 0.5px solid ${theme.colors.secondary};
  height: 100%;
  min-height: 422px;
  width: 1px;

  @media (max-width: 992px) {
    display: none;
  }
`;
